import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import Button from '../../../components/buttons/Button';
import { getCoinBackDataTestId } from '../../../components/Dialogs/CoinBackDialog/helpers';
import { I18Text } from '../../../components/i18Next/I18Text';
import { Overlay } from '../../../components/Overlay/Overlay';
import { Tooltip } from '../../../components/Tooltip/Tooltip';
import { useStores } from '../../../stores/useStores';

import styles from './CoinBackTutorial.module.scss';

type CheckCoinBackWidgetProps = {
  tooltipStyles: React.CSSProperties;
  setPopperElement: (el: HTMLElement | null) => void;
};

const CheckCoinBackWidget = ({ tooltipStyles, setPopperElement }: CheckCoinBackWidgetProps) => {
  const { coinBackStore } = useStores();
  const { t } = useTranslation();

  return (
    <Overlay backdropClassName={styles.overlayBackdrop} className={classNames(styles.overlay, styles.overlayClassName)}>
      <Tooltip
        showArrow
        arrowClassName={styles.tooltipArrow}
        setTooltipRef={setPopperElement}
        tooltipClassName={styles.tutorialTooltip}
        tooltipPositionStyle={{ ...tooltipStyles }}
      >
        <I18Text
          className={styles.checkOutCoinBack}
          components={{ subTitle: <span className={styles.boldSubtext} /> }}
          i18nKey="coinback.checkOutFeaturePrefix"
        />
        <Button
          btnType="main"
          data-testid={getCoinBackDataTestId('info-confirm-btn', true)}
          onClick={() => coinBackStore.setTutorialNextStep()}
        >
          {t('common.moreInfo')}
        </Button>
      </Tooltip>
    </Overlay>
  );
};

export default CheckCoinBackWidget;
